<template>
  <div class="home">
    <div class="info_title">
      {{ $i18n.t("info2_1") }}
    </div>
    <div class="info_line"></div>
    <div class="info_content">
      <p>
        {{ $i18n.t("info2_7") }}
      </p>
      <p>{{ $i18n.t("info2_2") }}</p>
      <p>{{ $i18n.t("info2_3") }}</p>
      <p>{{ $i18n.t("info2_4") }}</p>
      <p>{{ $i18n.t("info2_5") }}</p>
      <p >{{ $i18n.t("info2_6") }}</p>
      <!-- <p>
        {{ $i18n.t("info2_7") }}
      </p> -->
      <p>
        {{ $i18n.t("info2_8") }}
      </p>
      <p>
        {{ $i18n.t("info2_9") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lecturesinfo2",
  methods: {
    goPage() {},
  },
};
</script>
<style scoped >
.home {
  padding-bottom: 100px;
}
.info_title {
  width: 100%;
  text-align: center;
  font-size: 46px;
  color: #ffffff;
  border-bottom: solid 1px #fff;
  padding-bottom: 30px;
  margin-bottom: 100px;
  margin-top: 50px;
}
.info_content p {
  font-size: 20px;
  color: #ffffff;
  margin: 30px 0;
  text-indent: 2em; 
}
</style>